export default __webpack_public_path__ + "images/dd8579646d82e5f297aa43b914c83d3d.svg";